import React from "react";
import { useState, useEffect } from "react";
import "../styles/UserLogo.css";
import user_icon_downloadPage from "../images/user_icon_downloadPage.png"; // Make sure to import the icon if needed
import { userProfile } from "../Services/AllServices";
import { getName } from "../Storage/Storage";

const UserLogo = () => {
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [userProfileInfo, setUserProfileInfo] = useState({});

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const userName = await getName(); // Fetch user name from storage
        setName(userName);

        await userProfile((response) => {
          if (response && response.status === "success") {
            setUserProfileInfo(response.data); // Store user profile data
          }
        });

        setLoading(false); // Stop loading once data is fetched
      } catch (error) {
        console.error("!!!Failed to fetch user profile or total views", error);
        setLoading(false); // Stop loading even on error
      }
    };

    fetchUserProfile();
  }, []);

  return (
    <div className="user_profile">
      <div className="profile-header">
        <div className="avatar">
          <img src={user_icon_downloadPage} alt="user icon" />
        </div>
        <div className="user-info">
          <h1>{name || "Loading..."}</h1>
          <p>
            {!loading
              ? "Anavu " + (userProfileInfo.role || "Teacher")
              : "Loading role..."}
          </p>
        </div>
      </div>
    </div> // Closing div for user_profile
  );
};

export default UserLogo;
